import React from "react"
import '../../styles/BlogDetail.scss'
import blog5Pic1 from '../../images/blog/blog5_pic1.png'
import blog5 from '../../images/blog/blog5.jpg'
import { Image } from "semantic-ui-react"

const Blog5 = () => {
    return <div className="blog-detail-page">
        <div className="blog__detail__container">
            <div className="blog-title">Alasan Pembekuan SPayLater dan Cara Menghindarinya Penyebab Akun SPayLater Dibekukan dan Cara Mencegahnya</div>
            <div className="blog-time">April 1, 2025</div>
            <div className="blog-main-pic">
                <Image src={blog5} style={{borderRadius: '20px'}} />
            </div>
            <p className="blog-paragraph">
                Di era digital yang serba cepat ini, fitur paylater jadi pilihan favorit banyak orang untuk mempermudah pembayaran. Tidak heran, karena fitur ini membuat transaksi belanja lebih fleksibel dan bebas ribet, terutama untuk kebutuhan yang mendesak atau saat ingin membeli barang impian. Salah satunya menggunakan SPayLater—solusi pembayaran yang bikin transaksi jadi lebih mudah dan lebih cepat. Walaupun demikian, terkadang Anda juga bisa mengalami kendala seperti akun pembayaran yang dibekukan, yang mungkin saja disebabkan karena kita belum tahu cara membayar tagihan SPayLater.
            </p>
            <p className="blog-paragraph">
                Lalu, bagaimana kita dapat menyelesaikan permasalahan guna menghindari denda keterlambatan SPayLater? 
            </p>
            <p className="blog-paragraph">
                Nah, di artikel ini, kita akan membahas alasan di balik pembatasan akun SPayLater termasuk karena telat bayar tagihan SPayLater. Selain itu, kita akan membahas juga bagaimana cara mengatasi masalah dan denda keterlambatan SPayLater serta cara membayar tagihan SPayLater lewat aplikasi maupun secara offline.
            </p>
            <p className="blog-sub-title">
                Alasan Akun SPayLater Anda Dibekukan
            </p>
            <p className="blog-paragraph">
                Akun SPayLater Anda dapat dibekukan karena beberapa hal, di antaranya:
            </p>
            <ol className="blog-ol">
                <li><p className="blog-ol-sub-title">Pelunasan Tagihan yang Terlambat</p>Jika Anda tidak membayar tagihan SPayLater tepat waktu, sistem otomatis akan membekukan akun Anda untuk melindungi pihak penyedia layanan.
                </li>
                <li><p className="blog-ol-sub-title">Penyalahgunaan Layanan</p>Jika terdeteksi adanya aktivitas yang mencurigakan atau penyalahgunaan akun, maka akun Anda juga dapat dibekukan.
                </li>
                <li><p className="blog-ol-sub-title">Verifikasi Data</p>Selain itu, akun dapat dibekukan karena perlu dilakukan verifikasi data untuk memastikan keamanan data pengguna.
                </li>
            </ol>
            <p className="blog-sub-title">
                Solusi untuk Membuka Akun SPayLater yang Dibatasi
            </p>
            <p className="blog-paragraph">
                Jika akun Anda mengalami pembatasan akun, berikut adalah langkah-langkah yang dapat Anda lakukan:
            </p>
            <ol className="blog-ol">
                <li><p className="blog-ol-sub-title">Hubungi Customer Service</p>Langkah pertama adalah menghubungi customer service SPayLater melalui sambungan telepon  (021) 8060 4253 atau email ke customerservice@cmf.co.id. Nantinya Anda akan diinformasikan lebih  lanjut tentang alasan mengapa akun Anda dibatasidan langkah-langkah yang diperlukan untuk membuka pembatasan akun.
                </li>
                <li><p className="blog-ol-sub-title">Selesaikan Pembayaran Tertunggak</p>Jika pembatasan akundisebabkan karena telat bayar SPayLater, pastikan Anda menyelesaikan seluruh tagihan dan denda keterlambatan SPayLater Anda yang tertunda.
                </li>
                <li><p className="blog-ol-sub-title">Lengkapi Dokumen yang Diperlukan</p>Jika pembatasan akun disebabkan karena masalah verifikasi, Anda harus melengkapi dokumen yang diminta dan dikirimkan kepada pihak layanan.
                </li>
            </ol>
            <p className="blog-paragraph">
            Pastikan untuk melunasi tagihan SPayLater dengan tepat waktu untuk menghindari kemungkinan akun Anda dibekukan. Jika bingung, Berikut ini cara membayar tagihan SPayLater dengan benar:
            </p>
            <p className="blog-sub-title">
                Cara Membayar Tagihan SPayLater
            </p>
            <p className="blog-paragraph">
                Anda dapat membayar tagihan SPayLater dengan memilih tab Saya pada halaman utama aplikasi Shopee atau ShopeePay &gt; pilih SPayLater &gt; pilih Tagihan Saya &gt; pilih Bayar Sekarang &gt; pilih Metode Pembayaran &gt; pilih Konfirmasi &gt; pilih  Bayar Sekarang &gt; lakukan pembayaran.
            </p>
            <div className="blog-image-container">
                <Image src={blog5Pic1} />
            </div>
            <p className="blog-paragraph">
                Jika Anda sudah membayar tagihan SPayLater, Anda akan mendapatkan notifikasi di bagian “Keuangan” bahwa pembayaran Anda telah diterima. Limit SPayLater Anda akan segera dikembalikan maks. dalam 1x24 jam.
            </p>
            <p className="blog-sub-title">
                Pembayaran Tagihan SPayLater secara Offline
            </p>
            <p className="blog-sub-title-2">
                Cara Mendapatkan Kode Pembayaran Tagihan SPayLater
            </p>
            <p className="blog-paragraph">
                Pembayaran secara offline masih menjadi pilihan banyak orang, terutama bagi mereka yang tidak memiliki akses internet atau lebih nyaman membayar tagihan SPayLater dengan uang tunai. Bagi Anda yang ingin membayar tagihan SPayLater dengan uang tunai, Anda perlu mendapatkan kode tagihan terlebih dahulu. Berikut langkah-langkah mendapatkan kode pembayaran untuk membayar tagihan SPayLater:
            </p>
            <ol className="blog-ol">
                <li><p className="blog-ol-sub-title">Kode Pembayaran melalui Aplikasi</p>Untuk mendapatkan kode pembayaran SPayLater, pilih tab Saya pada halaman utama aplikasi Shopee &gt; pilih SPayLater &gt; pilih Tagihan Saya &gt; pilih Bayar Sekarang &gt; pilih Metode Pembayaran (Alfamart/Alfamidi/Dan+Dan/Indomaret) &gt; pilih Konfirmasi &gt; pilih  Bayar Sekarang &gt; Anda akan mendapatkan Kode Pembayaran.   <br /> Setelah Anda mendapatkan kode pembayaran, Anda bisa langsung datang ke merchant sesuai yang Anda pilih dan tunjukkan Kode Pembayaran untuk membayar tagihan SPayLater Anda.
                </li>
                <li><p className="blog-ol-sub-title">Kode Pembayaran melalui Customer Service</p>Untuk mendapatkan kode pembayaran tagihan SPaylater, Anda juga dapat menghubungi customer service SPayLater dan meminta informasi mengenai kode pembayaran agar Anda dapat membayar tagihan SPayLater.
                </li>
            </ol>
            <p className="blog-sub-title-2">
                Cara Melakukan Pembayaran Jika Tidak Dapat Mengakses Aplikasi ShopeePay
            </p>
            <p className="blog-paragraph">
                Jika Anda tidak dapat mengakses aplikasi ShopeePay untuk membayar tagihan SPayLater Anda, Anda dapat menghubungi customer service SPayLater di (021) 8060 4253 atau kirim email ke customerservice@cmf.co.id.
            </p>
            <p className="blog-paragraph">
                Sampaikan kepada petugas customer service bahwa Anda kesulitan dalam mengakses aplikasi SPayLater dan ingin membayar tagihan SPayLater. Petugas customer service akan melakukan pengecekan dan memberikan kode pembayaran untuk Anda membayar tagihan SPayLater di merchat-merchant yang sudah berkerjasama dengan SPayLater, yaitu Alfamart, Alfamidi, Dan+Dan dan Indomaret Cek list lengkap merchant di <a href="https://shopee.co.id/m/bayar-qris-spl-cicilan" target="_blank">sini</a>.
            </p>
            <p className="blog-paragraph">
                SPayLater oleh PT Commerce Finance berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK). ShopeePay telah berizin dan diawasi oleh Bank Indonesia.
            </p>


            <p className="blog-paragraph">
                ----
            </p>
            <p className="blog-sub-title">
                Butuh Bantuan?
            </p>
            <p className="blog-paragraph">
            Hubungi Customer Service PT Commerce Finance di nomor (021) 8060 4253 atau email ke  customerservice@support.cmf.co.id
            </p>
        </div>
    </div>

}

export default Blog5